<template>
  <div class="container" id="top-page">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >RMA Management</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <v-data-table
            v-if="headerItemsFilterDate.length <= 0"
            item-key="name"
            class="elevation-1 table-header"
            loading
            :headers="headersNotfound"
            :items-per-page="5"
            hide-default-footer
            :items="itemNotfound"
            loading-text="Loading... Please wait"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <div class="v-data-table-header">
                <v-btn
                  color="accent"
                  small
                  class="new-rma-btn"
                  outlined
                  elevation="2"
                  @click="newRMADialog = true"
                >
                  New RMA Disposition
                </v-btn>
                <v-data-footer
                  :pagination="pagination"
                  :options="options"
                  @update:options="updateOptions"
                  items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                  class="v-data-footer"
                />
              </div>
              <v-dialog v-model="newRMADialog" max-width="750px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">New RMA Disposition</span>
                  </v-card-title>
                  <v-card-text class="rma-dialog-card-text">
                    <v-card class="fieldset-card" outlined elevation="0">
                      <v-card-title class="fieldset-legend">
                        Part
                      </v-card-title>
                      <v-row class="v-row">
                        <div
                          v-for="(header, idx) in rmaDisposition.part"
                          :key="idx"
                        >
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              color="black"
                              v-model="header.value"
                              :label="header.text"
                            ></v-text-field>
                          </v-col>
                        </div>
                      </v-row>
                    </v-card>
                    <v-card class="fieldset-card" outlined elevation="0">
                      <v-card-title class="fieldset-legend">
                        Disposition
                      </v-card-title>
                      <v-row class="v-row">
                        <div
                          v-for="(header, idx) in rmaDisposition.disposition"
                          :key="idx"
                        >
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              v-if="header.text !== 'Create Corrective Action'"
                              color="black"
                              v-model="header.value"
                              :label="header.text"
                            ></v-text-field>
                            <v-checkbox
                              v-else
                              :label="header.text"
                              v-model="header.value"
                            >
                            </v-checkbox>
                          </v-col>
                        </div>
                      </v-row>
                    </v-card>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text> Add </v-btn>
                    <v-btn
                      color="gray darken-1"
                      text
                      @click="newRMADialog = false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-data-table>
          <v-data-table
            v-else
            :headers="rmaHeader"
            hide-default-footer
            :items="headerItemsFilterDate"
            class="elevation-1 table-header"
            @click:row="handleRowClick"
            :items-per-page="5"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <div class="v-data-table-header">
                <v-btn
                  color="accent"
                  small
                  class="new-rma-btn"
                  outlined
                  elevation="2"
                  @click="newRMADialog = true"
                >
                  New RMA Disposition
                </v-btn>
                <v-data-footer
                  :pagination="pagination"
                  :options="options"
                  @update:options="updateOptions"
                  items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                  class="v-data-footer"
                />
              </div>
              <v-dialog v-model="dialog" max-width="750px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">RMA Information</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <div v-for="(header, idx) in rmaHeader" :key="idx">
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              color="black"
                              v-if="checkIsEmpty(curRma[header.value])"
                              v-model="emptyItem"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                            <v-text-field
                              color="black"
                              v-else
                              v-model="curRma[header.value]"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                          </v-col>
                        </div>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="close">
                      OK
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="seeDetail">
                      See RMA Detail
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="newRMADialog" max-width="750px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">New RMA Disposition</span>
                  </v-card-title>
                  <v-card-text class="rma-dialog-card-text">
                    <v-card class="fieldset-card" outlined elevation="0">
                      <v-card-title class="fieldset-legend">
                        Part
                      </v-card-title>
                      <v-row class="v-row">
                        <div
                          v-for="(header, idx) in rmaDisposition.part"
                          :key="idx"
                        >
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              color="black"
                              v-model="header.value"
                              :label="header.text"
                            ></v-text-field>
                          </v-col>
                        </div>
                      </v-row>
                    </v-card>
                    <v-card class="fieldset-card" outlined elevation="0">
                      <v-card-title class="fieldset-legend">
                        Disposition
                      </v-card-title>
                      <v-row class="v-row">
                        <div
                          v-for="(header, idx) in rmaDisposition.disposition"
                          :key="idx"
                        >
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              v-if="header.text !== 'Create Corrective Action'"
                              color="black"
                              v-model="header.value"
                              :label="header.text"
                            ></v-text-field>
                            <v-checkbox
                              v-else
                              :label="header.text"
                              v-model="header.value"
                            >
                            </v-checkbox>
                          </v-col>
                        </div>
                      </v-row>
                    </v-card>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text> Add </v-btn>
                    <v-btn
                      color="gray darken-1"
                      text
                      @click="newRMADialog = false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template
              v-for="header in rmaHeader"
              v-slot:[`item.${header.value}`]="{ item }"
            >
              <template v-if="isBoolean(item[header.value])">
                <div class="checkbox_container" v-bind:key="item[header.value]">
                  <v-checkbox
                    v-bind:key="item[header.value]"
                    v-model="item[header.value]"
                    :true-value="true"
                    :false-value="false"
                    light
                    disabled
                    color="black"
                  ></v-checkbox>
                </div>
              </template>
              <template v-else>
                {{ item[header.value] }}
              </template>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel id="detail" style="margin-top: 30px">
        <v-expansion-panel-header class="Header"
          >RMA Details</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search2"
          />
          <br />
          <tableComponent
            :tableHeaders="rmaDetail"
            :tableItems="detailItemsFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.panel = Array.from(Array(2).keys());
        this.getBAQRma();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      headersNotfound: [{ text: "", value: "nf" }],
      itemNotfound: [{ nf: "Data not found!" }],
      rmaHeader: [
        { text: "Date Received", value: "RMARcpt_RcvDate" },
        { text: "RMANum", value: "RMARcpt_RMANum" },
        { text: "Line", value: "RMARcpt_RMALine" },
        { text: "Receipt", value: "RMARcpt_RMAReceipt" },
        { text: "Part", value: "RMADtl_PartNum" },
        { text: "Line Description", value: "RMADtl_LineDesc" },
        { text: "Warehouse", value: "RMARcpt_WareHouseCode" },
        { text: "Bin", value: "RMARcpt_BinNum", class: "min-width2" },
        { text: "Lot Number", value: "RMARcpt_LotNum" },
        { text: "Received Quantity", value: "RMARcpt_ReceivedQty" },
        { text: "Disposed Qty", value: "RMARcpt_DisposedQty" },
        { text: "UOM", value: "RMARcpt_ReceivedQtyUOM" },
        { text: "Legal Number", value: "RMARcpt_LegalNumber" },
      ],
      rmaDetail: [
        { text: "RMA", value: "RMADisp_RMANum" },
        { text: "Line", value: "RMADisp_RMALine" },
        { text: "Type", value: "RMADisp_DispType" },
        { text: "Quantity", value: "RMADisp_DispQty" },
        { text: "UOM", value: "RMADisp_DispQtyUOM" },
        { text: "WarehouseCode", value: "RMADisp_WareHouseCode" },
        { text: "Bin", value: "RMADisp_BinNum" },
        { text: "Lot Number", value: "RMARcpt_LotNum" },
        { text: "ReasonCode", value: "RMADisp_ReasonCode" },
        { text: "Inspected By", value: "RMADisp_InspectedBy" },
        { text: "Job Number", value: "RMADisp_JobNum" },
        { text: "Assembly Seq", value: "RMADisp_AssemblySeq" },
        { text: "Material Seq", value: "RMADisp_MtlSeq" },
        { text: "DispComment", value: "RMADisp_DispComment" },
        { text: "Request Move", value: "RMADisp_RequestMove" },
        { text: "Open", value: "RMADtl_OpenRMA" },
        { text: "Track Serial", value: "Part_TrackSerialNum" },
        { text: "NonConfTranID", value: "RMADisp_NonConfTranID" },
      ],
      rmaDisposition: {
        part: [
          { text: "Part", value: "" },
          { text: "Rev", value: "" },
          { text: "Description", value: "" },
          { text: "Attribute Set", value: "" },
          { text: "Lot", value: "" },
          { text: "Description", value: "" },
        ],
        disposition: [
          { text: "Dispose To", value: "" },
          { text: "Quantity", value: "" },
          { text: "Reason", value: "" },
          { text: "Inspected By", value: "" },
          { text: "Job Number", value: "" },
          { text: "Warehouse", value: "" },
          { text: "Bin", value: "" },
          { text: "Bin Description", value: "" },
          { text: "Create Corrective Action", value: false },
        ],
      },
      headerItems: [],
      detailItems: [],
      panel: [],
      curRma: {},
      search1: "",
      search2: "",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
      dialog: false,
      emptyItem: " ",
      newRMADialog: false,
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getRmaHead() {
      this.loadHeader();
    },
    getRmaDtl() {
      this.loadDetail();
    },
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getRmaHead", "getRmaDtl"]),
    headerItemsFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.headerItems == null || filterKey === "") return this.headerItems;
      return this.headerItems.filter((i) => {
        return (
          i.RMARcpt_RMANum.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.RMADtl_PartNum.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    headerItemsFilterDate() {
      if (this.headerItemsFilter.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.headerItemsFilter.filter((i) => {
          let day = i.RMARcpt_RcvDate.split("/")[0];
          let month = i.RMARcpt_RcvDate.split("/")[1];
          let year = i.RMARcpt_RcvDate.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.headerItemsFilter;
      }
    },
    detailItemsFilter() {
      const filterKey = (this.search2 || "").toLowerCase();
      if (this.detailItems == null || filterKey === "") return this.detailItems;
      return this.detailItems.filter((i) => {
        return (
          i.RMADisp_RMANum.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.RMADisp_RMALine.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.RMADisp_DispType.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    detailItemsFilterDate() {
      if (this.detailItemsFilter.length > 0) {
        // let from = new Date(this.fromdate2);
        // let to = new Date(this.todate2)
        // return this.detailItemsFilter.filter((i) => {
        //   let day = i.InvcHead_InvoiceDate.split('/')[0];
        //   let month = i.InvcHead_InvoiceDate.split('/')[1];
        //   let year = i.InvcHead_InvoiceDate.split('/')[2];
        //   let date = new Date(year, month-1, day);
        //   return date <= to && from <= date;
        // });
        return this.detailItemsFilter;
      } else {
        return this.detailItemsFilter;
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    checkIsEmpty(value) {
      if (typeof value === "string") {
        if (value.length == 0) return true;
        return false;
      }
      if (typeof value === "boolean") {
        return false;
      }
      return false;
    },
    seeDetail() {
      this.dialog = false;
      this.getBAQRMADetail(this.curRma);
    },
    isBoolean(value) {
      return typeof value === "boolean";
    },
    handleRowClick(item) {
      this.curRma = item;
      this.dialog = true;
    },
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    async getBAQRma() {
      await this.$store.dispatch("Data/getRMAHeadData");
      this.loadHeader();
    },
    async getBAQRMADetail(item) {
      await this.$store.dispatch("Data/getRMADtlData", {
        num: item.RMARcpt_RMANum,
        line: item.RMARcpt_RMALine,
        receipt: item.RMARcpt_RMAReceipt,
      });
      this.loadDetail();
    },
    loadHeader() {
      this.headerItems = [];
      if (this.getRmaHead && this.getRmaHead.length > 0) {
        this.getRmaHead.forEach((el) => {
          this.headerItems.push({
            RMARcpt_RcvDate: this.convertDate(el.RMARcpt_RcvDate),
            RMARcpt_RMANum: el.RMARcpt_RMANum,
            RMARcpt_RMALine: el.RMARcpt_RMALine,
            RMARcpt_RMAReceipt: el.RMARcpt_RMAReceipt,
            RMADtl_PartNum: el.RMADtl_PartNum,
            RMADtl_LineDesc: el.RMADtl_LineDesc,
            RMARcpt_WareHouseCode: el.RMARcpt_WareHouseCode,
            RMARcpt_BinNum: el.RMARcpt_BinNum,
            RMARcpt_LotNum: el.RMARcpt_LotNum,
            RMARcpt_ReceivedQty: el.RMARcpt_ReceivedQty,
            RMARcpt_DisposedQty: el.RMARcpt_DisposedQty,
            RMARcpt_ReceivedQtyUOM: el.RMARcpt_ReceivedQtyUOM,
            Calculated_QtytoDisp: el.Calculated_QtytoDisp,
            RMARcpt_ChangedBy: el.RMARcpt_ChangedBy,
            RMARcpt_LegalNumber: el.RMARcpt_LegalNumber,
            Part_TrackLots: el.Part_TrackLots,
            Part_TrackSerialNum: el.Part_TrackSerialNum,
          });
        });
      }
    },
    loadDetail() {
      this.detailItems = [];
      if (this.getRmaDtl && this.getRmaDtl.length > 0) {
        this.getRmaDtl.forEach((el) => {
          this.detailItems.push({
            RMADisp_RMANum: el.RMADisp_RMANum,
            RMADisp_RMALine: el.RMADisp_RMALine,
            RMADisp_RMADisp: el.RMADisp_RMADisp,
            RMADisp_DispType: el.RMADisp_DispType,
            RMADisp_DispQty: el.RMADisp_DispQty,
            RMADisp_DispQtyUOM: el.RMADisp_DispQtyUOM,
            RMADisp_WareHouseCode: el.RMADisp_WareHouseCode,
            RMADisp_BinNum: el.RMADisp_BinNum,
            RMARcpt_LotNum: el.RMARcpt_LotNum,
            RMADisp_ReasonCode: el.RMADisp_ReasonCode,
            RMADisp_InspectedBy: el.RMADisp_InspectedBy,
            RMADisp_RMAReceipt: el.RMADisp_RMAReceipt,
            RMADisp_JobNum: el.RMADisp_JobNum,
            RMADisp_AssemblySeq: el.RMADisp_AssemblySeq,
            RMADisp_MtlSeq: el.RMADisp_MtlSeq,
            RMADisp_DispComment: el.RMADisp_DispComment,
            RMADisp_RequestMove: el.RMADisp_RequestMove,
            RMADtl_OpenRMA: el.RMADtl_OpenRMA,
            Part_TrackSerialNum: el.Part_TrackSerialNum,
            RMADisp_NonConfTranID: el.RMADisp_NonConfTranID,
          });
        });
      }
      window.scrollTo({
        top: document.getElementById("detail").offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.text-start.sortable {
  border: 1px solid black;
  border-bottom: 1px solid black;
  background-color: #c1e4f7;
  height: 50px !important;
}

.text-start {
  height: 48px;
}

.text-start .checkbox_container {
  margin-left: 28%;
}

.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 48px !important;
}

.table td {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.new-rma-btn {
  position: absolute;
  margin-left: 15px;
  margin-top: 15px;
  color: black !important;
}

.v-data-table {
  overflow-x: auto;
  overflow-y: auto;
}

.v-data-footer {
  width: 100%;
}

.rma-dialog-card-text {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 24px !important;
}

.fieldset-legend {
  font-weight: 500;
  font-size: 20px;
}

.v-row {
  margin-left: -3px;
  column-gap: 15px;
  padding: 0 10px 10px 10px;
}

::v-deep .mdi-checkbox-marked::before {
  color: black;
}

tr:nth-child(even) {
  background-color: #edf9ff;
  white-space: nowrap;
}

tr:nth-child(odd) {
  white-space: nowrap;
}

table,
th,
td {
  border: 1px solid #e2e2e2;
  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: thin solid black !important;
}

.table td {
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ml-20 {
  margin-left: 100px;
}
.input_date {
  outline: #d1dfe3;
}
.filter_date {
  display: flex;
  flex-direction: row;
}
.filter_date_item {
  display: flex;
  flex-direction: column;
}
.mb-20 {
  margin-bottom: 50px;
}
.table-custom {
  width: 100%;
  margin-top: 20px;
}
table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}
th {
  border-bottom: 2px solid black;
}
td {
  text-align: center;
}
.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}
.input-search {
  margin-top: 5px;
  margin-bottom: 10px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}
.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}
</style>
